import React from 'react'
import { T } from '../../../traks'
import { Avatar } from './Avatar.js'
import { RenderIf } from '../../../helpers/RenderIf'

const PendingUsers = ({ users, deleteUser, resendInvite }) => {
	return (<RenderIf condition={users["pending_users"].length > 0}>
		<div className="mb-5">
			<div className="b mb-3"><T>Pending invites</T></div>
			{users["pending_users"].map((user, index) =>
				<div className="bg-white d-flex flex-column rounded-4 userlist shadow" key={"pe"+index}>
					<div className="d-flex justify-content-between">
						<div className="d-flex align-items-center py-4 ms-4">
							<div className="me-5">
								<Avatar screenName={user.screen_name} index={1} />
							</div>
							<div className="d-flex flex-column me-5">
								<div>{user.screen_name}</div>
								<div>{user.email}</div>
							</div>
							<div className="green_avatar rounded-4 py-1 px-3">
								<T>Pending</T>
							</div>
						</div>
						<div className="d-flex align-items-center">
							<button className="btn bg_dark_blue txt_white sibilus_border me-5" onClick={() => resendInvite(user.user_id)}>
								<T>Resend</T>
							</button>
							<button className="btn sibilus_border outline_red txt_red me-5" onClick={() => deleteUser(user.user_id)}>
								<T>Cancel Invitation</T>
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	</RenderIf>)
}

export { PendingUsers }
